import { useEffect, useState } from 'react';
// material
import CloseIcon from '@mui/icons-material/Close';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import TopicIcon from '@mui/icons-material/Topic';
import {
  Autocomplete,
  Button,
  Card,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { Box } from '@mui/system';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import { HiClipboardList } from 'react-icons/hi';
import { MdComment, MdToday } from 'react-icons/md';

// components
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';
//
import { randomIntFromInterval } from '../../utils/formatNumber';
import { fDate, fDateTime3, fDateTime4 } from '../../utils/formatTime';
import USERLIST from '../../_mocks_/user';
import ApiErrorMessage from '../Global/ApiErrorMessage';
import { StyledTableCell, StyledTableRow } from '../Global/Styling';
import globalService from '../services/globalServices';
import leadsService from '../services/leadsService';
import partnerService from '../services/partnerService';
import AppointmentToolbar from './AppointmentToolbar';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

const { StateList, CityList } = partnerService;
const { AppointmentsListHorizontal, LeadsList, CreateAppointment, DeleteAppointment } =
  leadsService;
const { MasterListType } = globalService;

export default function AppointmentList() {
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [addAppointment, setAddAppointment] = useState(false);
  const [addEditAppointmentTitle, setAddEditAppointmentTitle] = useState('');
  const [viewAppointment, setViewAppointment] = useState(false);
  const [token, setToken] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState('md');
  const [stateListMenu, setStateListMenu] = useState([]);
  const [cityListMenu, setCityListMenu] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [validationMsg, setValidationMsg] = useState('');
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [fromDate, setFromdate] = useState(new Date());
  const [tableColumnNamse, setTableColumnNamse] = useState([]);
  const [tableRowsNamse, setTableRowsNamse] = useState([]);
  const [classNames, setClassNames] = useState(['followBox', 'completedBox', 'appointmentBox']);
  const [selectedApountMent, setSelectedApountMent] = useState({});
  const [allLeadList, setAllLeadList] = useState([]);
  const [addressTypeMenu, setAddressTypeMenu] = useState([]);
  const [appointmentTypeMenu, setAppointmentTypeMenu] = useState([]);
  const [openApiError, setOpenApiError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [refreshComp, setRefreshComp] = useState(null);
  const [selectLead, setSelectLead] = useState(' ');
  const [addEditAppointment, setAddEditAppointment] = useState({
    lead: ' ',
    purpose: '',
    appointmentType: ' ',
    name: '',
    mobile: '',
    appointmentDate: '',
    addressType: ' ',
    address: '',
    landmark: '',
    state: null,
    city: null,
    pin: '',
    comments: ''
  });

  const { LoginData } = useLoginSelector();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };
  const getCityList = async (e, newValue) => {
    const CityListApiResponse = await CityList(
      {
        searchLiteral: '',
        stateId: newValue.stateId ? newValue.stateId : null
      },
      token
    );

    if (CityListApiResponse.action_status === 'success') {
      setCityListMenu(CityListApiResponse.data);
    } else {
      setCityListMenu([]);
    }
  };

  const handleSubmitAppointment = async (e) => {
    const pattern = /^[6-9][0-9]{9}$/;
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1);

    if (addEditAppointment.lead === ' ') {
      setDialogOpen(true);
      setValidationMsg('Please select lead');
      return;
    }
    if (addEditAppointment.purpose === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter purpose');
      return;
    }
    if (addEditAppointment.appointmentType === ' ') {
      setDialogOpen(true);
      setValidationMsg('Please select appointment type');
      return;
    }
    if (addEditAppointment.name === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter name');
      return;
    }
    if (!pattern.test(addEditAppointment.mobile)) {
      setDialogOpen(true);
      setValidationMsg('Please enter valid mobile number');
      return;
    }
    if (addEditAppointment.appointmentDate === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter appointment date');
      return;
    } else if (currentDate > new Date(addEditAppointment.appointmentDate)) {
      setDialogOpen(true);
      setValidationMsg('Please enter valid appointment date');
      return;
    }
    if (addEditAppointment.addressType === ' ') {
      setDialogOpen(true);
      setValidationMsg('Please select address type');
      return;
    }
    if (addEditAppointment.address === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter address');
      return;
    }
    if (addEditAppointment.state === null) {
      setDialogOpen(true);
      setValidationMsg('Please select state');
      return;
    }
    if (addEditAppointment.city === null) {
      setDialogOpen(true);
      setValidationMsg('Please select city');
      return;
    }
    if (addEditAppointment.pin === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter pin code');
      return;
    } else if (addEditAppointment.pin.length !== 6 || addEditAppointment.pin.length > 6) {
      setDialogOpen(true);
      setValidationMsg('Please enter valid pin code');
      return;
    }

    // AppointmentAdd list api

    let appointmentTimeValue = addEditAppointment.appointmentDate;
    appointmentTimeValue = `${appointmentTimeValue.split('T')[1]}:00`;

    const AppointMentCredentials = {
      companyId: companyId,
      upsertAppointmentDetailsModel: {
        addressType: addEditAppointment.addressType,
        appointmentAddress: addEditAppointment.address,
        appointmentComments: addEditAppointment.comments,
        appointmentId: selectedApountMent?.appointmentDetails?.leadAppointmentId
          ? selectedApountMent.appointmentDetails.leadAppointmentId
          : null,
        appointmentLandmark: addEditAppointment.landmark,
        appointmentStartDate: addEditAppointment.appointmentDate,
        appointmentStartTime: appointmentTimeValue,
        appointmentType: addEditAppointment.appointmentType,
        cityId: addEditAppointment.city ? addEditAppointment.city.cityId : null,
        contactName: addEditAppointment.name,
        leadId: addEditAppointment.lead ? JSON.parse(addEditAppointment.lead).leadId : null,
        mobileNumber: addEditAppointment.mobile,
        pinCode: addEditAppointment.pin,
        purpose: addEditAppointment.purpose,
        stateId: addEditAppointment.state ? addEditAppointment.state.stateId : null
      },
      userId: userId
    };

    const AppointmentsAddApiResponse = await CreateAppointment(AppointMentCredentials, token);

    if (AppointmentsAddApiResponse.status === 'success') {
      setAddAppointment(false);
      setRefreshComp(new Date());
      setAddEditAppointment({
        lead: ' ',
        purpose: '',
        appointmentType: ' ',
        name: '',
        mobile: '',
        appointmentDate: '',
        addressType: ' ',
        address: '',
        landmark: '',
        state: null,
        city: null,
        pin: '',
        comments: ''
      });
    } else {
      setOpenApiError(true);
      setErrorMessage('Something went wrong !');
    }
  };

  const handleDeleteAppointment = async (e) => {
    const credentials = {
      appointmentId: selectedApountMent?.appointmentDetails?.leadAppointmentId
        ? selectedApountMent.appointmentDetails.leadAppointmentId
        : null,
      companyId: companyId,
      stageId: allLeadList.length > 0 ? allLeadList[0].stageId : null,
      userId: userId
    };
    const DeleteAppointmentApi = await DeleteAppointment(credentials, token);
    if (DeleteAppointmentApi.status === 'success') {
      setViewAppointment(false);
      setDeleteConfirm(false);
      setAddEditAppointment({
        lead: ' ',
        purpose: '',
        appointmentType: ' ',
        name: '',
        mobile: '',
        appointmentDate: '',
        addressType: ' ',
        address: '',
        landmark: '',
        state: null,
        city: null,
        pin: '',
        comments: ''
      });
      setRefreshComp(new Date());
    } else {
      setOpenApiError(true);
      setErrorMessage('Something went wrong !');
    }
  };

  useEffect(async () => {
    if (LoginData !== null) {
      setToken(LoginData?.jwt);
      setCompanyId(LoginData?.companyId);
      setUserId(LoginData?.userId);

      // state list api
      const StateCredentials = {
        countryId: 101,
        searchLiteral: ''
      };
      const StateListApiResponse = await StateList(StateCredentials, LoginData?.jwt);
      if (StateListApiResponse.action_status === 'success') {
        setStateListMenu(StateListApiResponse.data);
      } else {
        setStateListMenu([]);
      }

      const appountMentCred = {
        userId: LoginData?.userId,
        subOrdinateId: null,
        appointmentDateTimeRequestModel: {
          fromDate: fromDate
          // toDate: '2022-12-31'
        }
      };

      const datesColumnNames = [];
      for (let i = 0; i < 7; i++) {
        datesColumnNames.push(new Date(new Date().setDate(new Date(fromDate).getDate() + i)));
      }
      setTableColumnNamse(datesColumnNames);

      const isAppointmentsList = await AppointmentsListHorizontal(appountMentCred, LoginData?.jwt);

      if (isAppointmentsList.status === 'success') {
        const rowsData = [];
        isAppointmentsList.data?.appointments?.appointments?.forEach(
          (appointment, apountmentIndex) => {
            const arayObj = {
              time: appointment.constrainedTime,
              id: apountmentIndex
            };
            datesColumnNames.forEach((columnKey) => {
              arayObj[columnKey] =
                Object.keys(appointment.appointmentHorizontalDateTimeModelMap).length > 0
                  ? getRowsArrayBydate(
                      columnKey,
                      appointment.appointmentHorizontalDateTimeModelMap,
                      classNames
                    )
                  : [];
            });
            rowsData.push(arayObj);
          }
        );
        setTableRowsNamse(rowsData);
      } else {
        setOpenApiError(true);
        setErrorMessage('Something went wrong !');
      }
    }

    const type = 'ADDRESS_TYPE';
    const AddressTypeApiResponse = await MasterListType(type, LoginData?.jwt);
    if (AddressTypeApiResponse.status === 'success') {
      setAddressTypeMenu(AddressTypeApiResponse.data.masterTypes);
    } else {
      setAddressTypeMenu([]);
    }

    const type1 = 'APPOINTMENT_TYPE';
    const AppointmentTypeApiResponse = await MasterListType(type1, LoginData?.jwt);
    if (AppointmentTypeApiResponse.status === 'success') {
      setAppointmentTypeMenu(AppointmentTypeApiResponse.data.masterTypes);
    } else {
      setAppointmentTypeMenu([]);
    }

    setTimeout(() => {
      const getLeadList = localStorage.getItem('leadList');
      if (getLeadList) {
        setAllLeadList(JSON.parse(getLeadList));
      }
    }, 1000);
  }, [fromDate, refreshComp]);

  return (
    <Page title="Partner Management System || Leads">
      <Container maxWidth="">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Appointment" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>
          <Card>
            <AppointmentToolbar
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
              parent="appointment-leads"
              setAddAppointment={setAddAppointment}
              setAddEditAppointmentTitle={setAddEditAppointmentTitle}
              setFromdate={setFromdate}
              setTableRowsNamse={setTableRowsNamse}
              fromDate={fromDate}
              allLeadList={allLeadList}
              selectLead={selectLead}
              setSelectLead={setSelectLead}
              setAddEditAppointment={setAddEditAppointment}
            />
            <Scrollbar>
              <TableContainer sx={{ overflow: 'auto', height: '68vh' }} aria-label="simple table">
                <Table>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>Time</StyledTableCell>
                      {
                        // Prashant
                        tableColumnNamse.length > 0
                          ? tableColumnNamse.map((columnDate, columnIndex) => (
                              <StyledTableCell>{fDate(columnDate)}</StyledTableCell>
                            ))
                          : ''
                      }
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {tableRowsNamse.length > 0
                      ? tableRowsNamse.map((leadsItem, leadsIndex) => (
                          <StyledTableRow key={leadsIndex}>
                            <StyledTableCell className="FileTypeName colorBlue">
                              <strong>{leadsItem.time}</strong>
                            </StyledTableCell>
                            {tableColumnNamse.map((columnDate, columnIndex) => (
                              <StyledTableCell key={columnIndex}>
                                {leadsItem[columnDate]?.map((lead, leadIndex) => (
                                  <Box
                                    key={leadIndex}
                                    className={lead.leadStatus}
                                    onClick={(e) => {
                                      setViewAppointment(true);
                                      setSelectedApountMent(lead);
                                      const StateObj = {
                                        countryId: 101,
                                        stateCode: null,
                                        stateId: lead.appointmentDetails.appointmentStateId,
                                        stateName: lead.appointmentDetails.appointmentState
                                      };
                                      const CityObj = {
                                        cityId: lead.appointmentDetails.appointmentCityId,
                                        cityCode: null,
                                        cityName: lead.appointmentDetails.appointmentCity,
                                        stateId: lead.appointmentDetails.appointmentStateId
                                      };
                                      const DateTime = `${lead.formatedDate} ${lead.appointmentTime}`;

                                      const itemValue = {
                                        leadId: lead.appointmentDetails.leadId,
                                        customerName: lead.appointmentDetails.leadName,
                                        leadOwnerName: lead.appointmentDetails.leadOwnerName,
                                        leadOwnerId: lead.appointmentDetails.leadOwnerId
                                      };
                                      setAddEditAppointment({
                                        lead: JSON.stringify(itemValue),
                                        purpose: lead.appointmentDetails.purpose,
                                        appointmentType: lead.appointmentDetails.appointmentTypeId,
                                        name: lead.appointmentDetails.contactPersonName,
                                        mobile: lead.appointmentDetails.contactMobileNumber,
                                        appointmentDate: DateTime ? fDateTime4(DateTime) : '',
                                        addressType: lead.appointmentDetails.addressTypeId,
                                        address: lead.appointmentDetails.appointmentAddress,
                                        landmark: lead.appointmentDetails.contactLandmark,
                                        state: StateObj,
                                        city: CityObj,
                                        pin: lead.appointmentDetails.pincode,
                                        comments: lead.appointmentDetails.appointmentComments
                                      });
                                    }}
                                  >
                                    <Typography variant="">
                                      {lead.appointmentDetails.contactPersonName}
                                    </Typography>
                                  </Box>
                                ))}
                              </StyledTableCell>
                            ))}
                          </StyledTableRow>
                        ))
                      : ''}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
            {/* Add appointment popup start */}
            <Dialog
              className="PopupBox"
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              open={addAppointment}
              fullWidth={fullWidth}
              maxWidth={maxWidth}
            >
              <DialogTitle className="popupTitle">
                <Typography variant="h6">{addEditAppointmentTitle}</Typography>
                <IconButton
                  onClick={(e) => {
                    setAddAppointment(false);
                    setAddEditAppointment({
                      lead: ' ',
                      purpose: '',
                      appointmentType: ' ',
                      name: '',
                      mobile: '',
                      appointmentDate: '',
                      addressType: ' ',
                      address: '',
                      landmark: '',
                      state: null,
                      city: null,
                      pin: '',
                      comments: ''
                    });
                  }}
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <Box className="statusBox statusBoxEdit">
                  <Typography variant="body2">Lead Owner:</Typography>
                  <Typography variant="subtitle2" className="ml-1">
                    {addEditAppointment.lead !== ' '
                      ? JSON.parse(addEditAppointment.lead).leadOwnerName
                      : ''}
                  </Typography>
                </Box>
                <Grid container spacing={{ xs: 1, sm: 2, md: 2 }}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Select
                        id="Lead"
                        displayEmpty
                        inputProps={{
                          className: `textInput customSelectBox dissabledMenu${addEditAppointment.lead}`
                        }}
                        value={addEditAppointment.lead}
                        onChange={(e) => {
                          const prevArray = addEditAppointment;
                          prevArray.lead = e.target.value;
                          setAddEditAppointment({ ...prevArray });
                        }}
                      >
                        <MenuItem value=" " disabled>
                          Select Lead
                        </MenuItem>
                        {allLeadList.length > 0 &&
                          allLeadList.map((leadItem, leadIndex) => {
                            const itemValue = {
                              leadId: leadItem.leadId,
                              customerName: leadItem.customerName,
                              leadOwnerName: leadItem.leadOwnerName,
                              leadOwnerId: leadItem.leadOwnerId
                            };
                            return (
                              <MenuItem value={JSON.stringify(itemValue)}>
                                {itemValue.customerName}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl required fullWidth className="formGroup">
                      <TextField
                        id=""
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Purpose"
                        value={addEditAppointment.purpose}
                        onChange={(e) => {
                          const prevArray = addEditAppointment;
                          prevArray.purpose = e.target.value;
                          setAddEditAppointment({ ...prevArray });
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Select
                        id=""
                        displayEmpty
                        inputProps={{
                          className: `textInput customSelectBox dissabledMenu${addEditAppointment.appointmentType}`
                        }}
                        value={addEditAppointment.appointmentType}
                        onChange={(e) => {
                          const prevArray = addEditAppointment;
                          prevArray.appointmentType = e.target.value;
                          setAddEditAppointment({ ...prevArray });
                        }}
                      >
                        <MenuItem value=" " disabled>
                          Select Appointment Type
                        </MenuItem>
                        {appointmentTypeMenu.length > 0
                          ? appointmentTypeMenu.map((item, index) => (
                              <MenuItem value={item.typeId} key={index}>
                                {item.typeName}
                              </MenuItem>
                            ))
                          : ''}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl required fullWidth className="formGroup">
                      <TextField
                        id="Prospect Name"
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Prospect Name"
                        value={addEditAppointment.name}
                        onChange={(e) => {
                          const prevArray = addEditAppointment;
                          prevArray.name = e.target.value;
                          setAddEditAppointment({ ...prevArray });
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl required fullWidth className="formGroup">
                      <TextField
                        id="Mobile"
                        type="number"
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Prospect Mobile"
                        value={addEditAppointment.mobile}
                        onChange={(e) => {
                          const prevArray = addEditAppointment;
                          prevArray.mobile = e.target.value;
                          setAddEditAppointment({ ...prevArray });
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl required fullWidth className="formGroup">
                      <TextField
                        type="datetime-local"
                        id="Date"
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Select Appointment Date Time"
                        value={addEditAppointment.appointmentDate}
                        onChange={(e) => {
                          const prevArray = addEditAppointment;
                          prevArray.appointmentDate = e.target.value;
                          setAddEditAppointment({ ...prevArray });
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Select
                        fullWidth
                        inputProps={{
                          className: `textInput customSelectBox dissabledMenu${addEditAppointment.addressType}`
                        }}
                        value={addEditAppointment.addressType}
                        onChange={(e) => {
                          const prevArray = addEditAppointment;
                          prevArray.addressType = e.target.value;
                          setAddEditAppointment({ ...prevArray });
                        }}
                        sx={{ minWidth: '200px' }}
                      >
                        <MenuItem value=" " disabled>
                          Select Address Type
                        </MenuItem>
                        {addressTypeMenu.length > 0
                          ? addressTypeMenu.map((item, index) => (
                              <MenuItem value={item.typeId}>{item.typeName}</MenuItem>
                            ))
                          : ''}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4}>
                    <FormControl required fullWidth className="formGroup">
                      <TextField
                        id="Address"
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Appointment Address"
                        value={addEditAppointment.address}
                        onChange={(e) => {
                          const prevArray = addEditAppointment;
                          prevArray.address = e.target.value;
                          setAddEditAppointment({ ...prevArray });
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl required fullWidth className="formGroup">
                      <TextField
                        id="Landmark"
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Appointment Landmark"
                        value={addEditAppointment.landmark}
                        onChange={(e) => {
                          const prevArray = addEditAppointment;
                          prevArray.landmark = e.target.value;
                          setAddEditAppointment({ ...prevArray });
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Autocomplete
                        id="combo-box-demo"
                        options={stateListMenu}
                        size="small"
                        value={
                          addEditAppointment.state !== null
                            ? addEditAppointment.state.stateName
                            : null
                        }
                        onChange={(e, newValue) => {
                          setCityListMenu([]);
                          const prevArray = addEditAppointment;
                          prevArray.city = null;
                          prevArray.state = newValue;
                          setAddEditAppointment({ ...prevArray });
                          if (newValue) {
                            getCityList(e, newValue);
                          }
                        }}
                        getOptionLabel={(option) =>
                          option.stateName ? option.stateName : addEditAppointment.state.stateName
                        }
                        renderOption={(props, option) => <li {...props}>{option.stateName}</li>}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth placeholder="Select State" />
                        )}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Autocomplete
                        id="combo-box-demo1"
                        options={cityListMenu}
                        size="small"
                        value={
                          addEditAppointment.city !== null ? addEditAppointment.city.cityName : null
                        }
                        onChange={(e, newValue) => {
                          const prevArray = addEditAppointment;
                          prevArray.city = newValue;
                          setAddEditAppointment({ ...prevArray });
                        }}
                        getOptionLabel={(option) =>
                          option.cityName ? option.cityName : addEditAppointment?.city?.cityName
                        }
                        renderOption={(props, option) => <li {...props}>{option.cityName}</li>}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth placeholder="Select City" />
                        )}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl required fullWidth className="formGroup">
                      <TextField
                        id="Pin Code"
                        type="number"
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Pin Code"
                        value={addEditAppointment.pin}
                        onChange={(e) => {
                          const prevArray = addEditAppointment;
                          prevArray.pin = e.target.value;
                          setAddEditAppointment({ ...prevArray });
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl required fullWidth className="formGroup">
                      <TextField
                        id="Comments"
                        multiline
                        rows={2}
                        inputProps={{ className: '' }}
                        fullWidth
                        placeholder="Write Comments"
                        value={addEditAppointment.comments}
                        onChange={(e) => {
                          const prevArray = addEditAppointment;
                          prevArray.comments = e.target.value;
                          setAddEditAppointment({ ...prevArray });
                        }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={(e) => {
                    handleSubmitAppointment(e);
                    // setAddAppointment(false);
                  }}
                  variant="contained"
                  className="mainBtn"
                >
                  Submit
                </Button>
              </DialogActions>
            </Dialog>
            {/* Add appointment popup end */}

            {/* View appointment popup start */}
            <Dialog
              className="PopupBox"
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              open={viewAppointment}
              fullWidth
              onClose={(e) => setViewAppointment(false)}
            >
              <DialogTitle className="popupTitle">
                <Box className="displayFlex">
                  <Tooltip title="Edit" placement="top" arrow>
                    <IconButton
                      onClick={(e) => {
                        setViewAppointment(false);
                        setAddAppointment(true);
                        setAddEditAppointmentTitle('Edit Appointment');
                      }}
                    >
                      <AiFillEdit size={20} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete" placement="top" arrow>
                    <IconButton
                      onClick={(e) => {
                        setDeleteConfirm(true);
                      }}
                    >
                      <AiFillDelete size={20} />
                    </IconButton>
                  </Tooltip>
                </Box>
                <IconButton
                  onClick={(e) => {
                    setViewAppointment(false);
                    setAddEditAppointment({
                      lead: ' ',
                      purpose: '',
                      appointmentType: ' ',
                      name: '',
                      mobile: '',
                      appointmentDate: '',
                      addressType: ' ',
                      address: '',
                      landmark: '',
                      state: null,
                      city: null,
                      pin: '',
                      comments: ''
                    });
                  }}
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <Box className="displayFlex" mb={2}>
                  <MdToday className="viewLabelIcon" size={24} />
                  <Box>
                    <Typography variant="h6" className="labelValue colorBlue">
                      {selectedApountMent?.appointmentDetails?.purpose
                        ? selectedApountMent.appointmentDetails.purpose
                        : ''}
                    </Typography>
                    <Typography variant="body2" className="labelText">
                      {selectedApountMent?.formatedTime ? selectedApountMent.formatedTime : ''}
                    </Typography>
                  </Box>
                </Box>
                <Box className="displayFlex" mb={2}>
                  <PermContactCalendarIcon className="viewLabelIcon" size={24} />
                  <Box>
                    <Typography variant="body2" className="labelText">
                      Lead Owner
                    </Typography>
                    <Typography variant="subtitle2" className="labelValue">
                      {selectedApountMent?.appointmentDetails?.leadOwnerName
                        ? selectedApountMent.appointmentDetails.leadOwnerName
                        : ''}
                    </Typography>
                  </Box>
                </Box>
                <Box className="displayFlex" mb={2}>
                  <HiClipboardList className="viewLabelIcon" size={24} />
                  <Box>
                    <Typography variant="body2" className="labelText">
                      Appointment Type
                    </Typography>
                    <Typography variant="subtitle2" className="labelValue">
                      {selectedApountMent?.appointmentDetails?.appointmentType
                        ? selectedApountMent.appointmentDetails.appointmentType
                        : ''}
                    </Typography>
                  </Box>
                </Box>
                <Box className="displayFlex" mb={2}>
                  <TopicIcon className="viewLabelIcon" size={24} />
                  <Box>
                    <Typography variant="body2" className="labelText">
                      Appointment Address
                    </Typography>
                    <Typography variant="subtitle2" className="labelValue">
                      {selectedApountMent?.appointmentDetails?.appointmentAddress},&nbsp;
                      {selectedApountMent?.appointmentDetails?.appointmentCity},&nbsp;
                      {selectedApountMent?.appointmentDetails?.appointmentState},
                    </Typography>
                  </Box>
                </Box>
                <Box className="displayFlex">
                  <MdComment className="viewLabelIcon" size={24} />
                  <Box>
                    <Typography variant="body2" className="labelText">
                      Comments
                    </Typography>
                    <Typography variant="subtitle2" className="labelValue">
                      {selectedApountMent?.appointmentDetails?.appointmentComments
                        ? selectedApountMent.appointmentDetails.appointmentComments
                        : ''}
                    </Typography>
                  </Box>
                </Box>
              </DialogContent>
              {/* <DialogActions>
                <Button
                  onClick={(e) => setViewAppointment(false)}
                  variant="contained"
                  className="mainBtn deleteBtn"
                >
                  Delete
                </Button>
                <Button
                  onClick={(e) => {
                    setViewAppointment(false);
                    setAddAppointment(true);
                  }}
                  variant="contained"
                  className="mainBtn"
                >
                  Edit
                </Button>
              </DialogActions> */}
            </Dialog>
            {/* View appointment popup end */}
          </Card>
          <Dialog
            open={dialogOpen}
            onClose={(e) => setDialogOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">{validationMsg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={(e) => setDialogOpen(false)}>Retry</Button>
            </DialogActions>
          </Dialog>
          <ApiErrorMessage
            openApiError={openApiError}
            setOpenApiError={setOpenApiError}
            errorMessage={errorMessage}
          />
          <Dialog
            fullWidth
            className="PopupBox"
            open={deleteConfirm}
            // onClose={(e) => setDeleteConfirm(false)}
          >
            <DialogTitle className="popupTitle">
              <Typography variant="h6">Delete Confirmation</Typography>
              <IconButton onClick={(e) => setDeleteConfirm(false)} size="small">
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              <Typography>Are you sure you want to delete?</Typography>
            </DialogContent>
            <DialogActions>
              <Box mr={2}>
                <Button onClick={(e) => setDeleteConfirm(false)} variant="outlined" color="primary">
                  Close
                </Button>
              </Box>
              <Button
                onClick={(e) => {
                  handleDeleteAppointment(e);
                }}
                variant="contained"
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Container>
    </Page>
  );
}

function getRowsArrayBydate(columnDate, dataBydates, classNames) {
  const letsDate = new Date(columnDate);
  letsDate.setHours(0, 0, 0);
  let returnable = [];
  Object.keys(dataBydates).forEach((databydate, dateByIndex) => {
    const letsDateFromArr = new Date(databydate);
    letsDateFromArr.setHours(0, 0, 0);

    if (String(letsDate) === String(letsDateFromArr)) {
      dataBydates[databydate].forEach((item) => {
        const splitedTime = item.appointmentTime.split(':');
        letsDateFromArr.setHours(splitedTime[0], splitedTime[1], splitedTime[2]);
        item.leadStatus = classNames[randomIntFromInterval(0, 2)];
        item.formatedDate = fDate(letsDateFromArr);
        item.formatedTime = fDateTime3(letsDateFromArr);
      });

      returnable = dataBydates[databydate];
    }
  });
  return returnable;
}

function CustomInput({ addEditAppointment, setAddEditAppointment, inputKey, inputPlaceHolder }) {
  const [purpose, setPurpose] = useState('');
  useEffect(() => {
    setPurpose(addEditAppointment[inputKey]);
  }, [addEditAppointment]);
  return (
    <TextField
      id=""
      inputProps={{ className: 'textInput' }}
      fullWidth
      placeholder={inputPlaceHolder}
      value={purpose}
      onBlur={(e) => {
        const prevData = { ...addEditAppointment };
        prevData[inputKey] = e.target.value;
        setAddEditAppointment(prevData);
      }}
      onChange={(e) => {
        setPurpose(e.target.value);
      }}
    />
  );
}
